import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule, MatOptionModule } from "@angular/material/core";
import { NgxMaskModule } from "ngx-mask";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatListModule } from "@angular/material/list";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTabsModule } from "@angular/material/tabs";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSelectModule } from "@angular/material/select";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialFileInputModule } from "ngx-material-file-input";
import { NgxBootstrapMultiselectModule } from "ngx-bootstrap-multiselect";
import { NgxMultiselectModule } from "@ngx-lib/multiselect";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { MatDialogModule } from "@angular/material/dialog";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import {MatChipsModule} from '@angular/material/chips';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";


const materialModules = [
  MatButtonModule,
  MatInputModule,
  MatListModule,
  MatIconModule,
  MatTooltipModule,
  MatDatepickerModule,
  MatNativeDateModule,
  NgxMaskModule.forRoot(),
  MatButtonToggleModule,
  MatFormFieldModule,
  MatSlideToggleModule,
  MatTabsModule,
  MatCheckboxModule,
  MatOptionModule,
  MatSelectModule,
  MaterialFileInputModule,
  NgxBootstrapMultiselectModule,
  NgxMultiselectModule,
  NgMultiSelectDropDownModule.forRoot(),
  MatDialogModule,
  NgbModule,
  MatExpansionModule,
  MatTableModule,
  MatPaginatorModule,
  MatChipsModule,
  MatProgressSpinnerModule
];

@NgModule({
  declarations: [],
  imports: [materialModules],
  exports: [materialModules],
})
export class MaterialModule {}
